var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-input"},[_c('el-autocomplete',{staticClass:"inline-input",style:({width:_vm.width+'px'}),attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请输入名称"},on:{"select":_vm.handleSelect},model:{value:(_vm.valueInside),callback:function ($$v) {_vm.valueInside=$$v},expression:"valueInside"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }